import { generateNgrxServiceClient } from '@essent/ngrx-service-wrapper';
import { emobilityClient } from '@integration/api-client/emobility';

export const { actions, effects } = generateNgrxServiceClient(
  'Emobility',
  emobilityClient
);
